<template>
  <div class="marketplace-app-list">
    <a-page-header title="Tüm Uygulamalar" @back="() => $router.push('/marketplace')" />
    <a-spin :spinning="loading">
      <a-row :gutter="[16, 16]" v-if="!loading">
        <a-col
          :xs="24"
          :sm="12"
          :md="6"
          :lg="6"
          :xl="6"
          v-for="app in filteredApps"
          :key="app.id">
          <router-link :to="`/marketplace/app/${app.slug}`" style="display:block">
            <a-card hoverable class="marketplace-list-card">
              <div class="card-content">
                <div class="card-icon-wrap">
                  <img v-if="app.icon" :src="app.icon" alt="icon" class="card-icon" />
                </div>
                <div class="card-title">{{ app.name }}</div>
                <div class="card-subtitle">Kolay Kurulum</div>
              </div>
            </a-card>
          </router-link>
        </a-col>
      </a-row>
      <a-empty v-if="!loading && filteredApps.length === 0" />
    </a-spin>
  </div>
</template>

<script>
import { ref, onMounted, computed } from 'vue'
import axios from 'axios'
import { csPortalApi } from '@/utils/csPortal'

export default {
  name: 'MarketPlaceAppList',
  setup () {
    const apps = ref([])
    const loading = ref(false)
    const categories = ref([])

    const getCategoryName = (categoryId) => {
      const cat = categories.value.find(c => c.id === categoryId)
      return cat ? cat.name : ''
    }

    const fetchData = async () => {
      loading.value = true
      try {
        const [appsRes, categoriesRes] = await Promise.all([
          axios.get(`${csPortalApi()}/marketplace/products`),
          axios.get(`${csPortalApi()}/marketplace/categories`)
        ])
        apps.value = appsRes.data
        categories.value = categoriesRes.data
      } catch (e) {
        console.error('Error fetching apps:', e)
      } finally {
        loading.value = false
      }
    }

    const filteredApps = computed(() => {
      return [...apps.value].sort((a, b) => {
        const catA = (getCategoryName(a.category_id) || '').toLowerCase()
        const catB = (getCategoryName(b.category_id) || '').toLowerCase()
        if (catA < catB) return -1
        if (catA > catB) return 1
        return (a.name || '').toLowerCase().localeCompare((b.name || '').toLowerCase())
      })
    })

    onMounted(fetchData)

    return { apps, loading, categories, filteredApps, fetchData, getCategoryName }
  }
}
</script>

<style scoped>
.marketplace-list-card {
  min-height: 220px;
}
.card-content {
  padding: 8px 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.card-icon-wrap {
  width: 100px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 8px;
}
.card-icon {
  width: 100px;
  min-height: 25px;
  max-height: 35px;
  object-fit: contain;
  object-position: left;
}
.card-title {
  color: #1890ff;
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 8px;
}
.card-subtitle {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 8px;
}
.card-desc {
  color: #888;
  font-size: 15px;
  line-height: 1.4;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
